import { useStore } from '@/providers/app-store-provider';
import { initializeReporting } from '@/reporting';
import { preloadSnowplowTracker } from '@/reporting/sdkLoader';
import logger from '@/utils/client-logger';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useLayoutEffect, useRef } from 'react';

/** 在 passive effect 前启动关键埋点 Provider，并防止 Strict Mode 重入。 */
export function useCriticalReportingBootstrap({ deviceType }: { deviceType: EPlatform }): void {
  const startedRef = useRef(false);
  const trackingConfig = useStore((state) => state.publicResourceData?.jsonvalues?.tracking_config);
  const sgtmPixelConfig = useStore((state) => state.sgtmPixelConfig);

  useLayoutEffect(() => {
    if (startedRef.current) return;

    startedRef.current = true;
    // 只提前启动下载，不等待模块完成，避免阻塞同步 Provider 注册与初始化。
    void preloadSnowplowTracker(deviceType).catch((error) =>
      logger.error('Critical reporting Snowplow preload failed:', error),
    );
    void initializeReporting(deviceType, trackingConfig, sgtmPixelConfig);
  }, [deviceType, sgtmPixelConfig, trackingConfig]);
}
